// 此文件是通过脚本生成的，直接编辑无效！！！
// 页面路由配置
export default [
    {
        path: '/detail-monthly',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/achievement-monthly/detail-monthly-old.jsx'),
    },
    {
        path: '/monthly/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/achievement-monthly/detail-monthly.jsx'),
    },
    {
        path: '/achievement-monthly',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/achievement-monthly/index-old.jsx'),
    },
    {
        path: '/monthly/list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/achievement-monthly/index.jsx'),
    },
    {
        path: '/activity-king',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activationKing/ActivationKing.jsx'),
    },
    {
        path: '/activeDetails/:id',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/active-aggregation/ActiveDetails.jsx'),
    },
    {
        path: '/aggregation',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/active-aggregation/Aggregation.jsx'),
    },
    {
        path: '/activate-receive-envelopes-Q4',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/activate-receive-envelopes-Q4/index.jsx'),
    },
    {
        path: '/activate-receive-envelopes',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/activate-receive-envelopes/index.jsx'),
    },
    {
        path: '/active-clock-in/link',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/active-clock-in/AppLinkPage.jsx'),
    },
    {
        path: '/active-clock-in/history',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/active-clock-in/HistoryPrize.jsx'),
    },
    {
        path: '/active-clock-in',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/active-clock-in/index.jsx'),
    },
    {
        path: '/active-clock-in/share',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/active-clock-in/Share.jsx'),
    },
    {
        path: '/SignUp',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/active-clock-in/SignUp.jsx'),
    },
    {
        path: '/activity-square',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/activity-square/index.jsx'),
    },
    {
        path: '/activity-zone',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/activity-zone/index.jsx'),
    },
    {
        path: '/alipay-blue-guide',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-blue-guide/index.jsx'),
    },
    {
        path: '/alipay-blue-operate',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-blue-operate/index.jsx'),
    },
    {
        path: '/alipay-blue',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-blue/index.jsx'),
    },
    {
        path: '/alipay-cs66',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-cs66/index.jsx'),
    },
    {
        path: '/alipay-touch-guide',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-touch-guide/index.jsx'),
    },
    {
        path: '/alipay-touch-operate',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-touch-operate/index.jsx'),
    },
    {
        path: '/alipay-touch',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/alipay-touch/index.jsx'),
    },
    {
        path: '/attracting-wealth-reward',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/attracting-wealth-reward/index.jsx'),
    },
    {
        path: '/attracting-wealth-reward/record',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/attracting-wealth-reward/record.jsx'),
    },
    {
        path: '/attracting-wealth-reward/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/attracting-wealth-reward/rule.jsx'),
    },
    {
        path: '/botn-pay-plan',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/bothpay-plan/index.jsx'),
    },
    {
        path: '/botn-pay-plan/merchant-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/bothpay-plan/merchantList.jsx'),
    },
    {
        path: '/botn-pay-plan/record',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/bothpay-plan/record.jsx'),
    },
    {
        path: '/botn-pay-plan/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/bothpay-plan/rule.jsx'),
    },
    {
        path: '/breach-challenge/rank',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/breach-challenge/breachRank.jsx'),
    },
    {
        path: '/breach-challenge/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/breach-challenge/breachRule.jsx'),
    },
    {
        path: '/breach-challenge/home',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/breach-challenge/index.jsx'),
    },
    {
        path: '/card-subsidy',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/card-subsidy/index.jsx'),
    },
    {
        path: '/card-subsidy/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/card-subsidy/rule.jsx'),
    },
    {
        path: '/cashback2024',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/cashback-2024/index.jsx'),
    },
    {
        path: '/activation/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/compliance-activation/detail.jsx'),
    },
    {
        path: '/activation/sprint',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/compliance-activation/Sprint.jsx'),
    },
    {
        path: '/cs66/activity',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/cs66/index.jsx'),
    },
    {
        path: '/divide-bonus2024/ranks/butler-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/butler-list.jsx'),
    },
    {
        path: '/divide-bonus2024/records',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/DivideRecords.jsx'),
    },
    {
        path: '/divide-bonus2024/rules',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/DivideRules.jsx'),
    },
    {
        path: '/divide-bonus2024/rulesOld',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/DivideRulesOld.jsx'),
    },
    {
        path: '/divide-bonus2024',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/index.jsx'),
    },
    {
        path: '/divide-bonus2024/ranks',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/divide-bonus2/MyRanks.jsx'),
    },
    {
        path: '/dragon-boat-festival2024',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/dragon-boat-festival/index.jsx'),
    },
    {
        path: '/dragon-boat-festival2024/my-prize',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/dragon-boat-festival/myPrize.jsx'),
    },
    {
        path: '/dragon-boat-festival2024/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/dragon-boat-festival/rule.jsx'),
    },
    {
        path: '/give_coupon',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/give-coupon/index.jsx'),
    },
    {
        path: '/goldMedalCultivation',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/gold-medal-cultivation/index.jsx'),
    },
    {
        path: '/goldMedalCultivation/ranking',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/gold-medal-cultivation/ranking.jsx'),
    },
    {
        path: '/goldMedalCultivation/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/gold-medal-cultivation/rule.jsx'),
    },
    {
        path: '/head-card-incentives/historical-rewards',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/head-card-incentives/historical-rewards.jsx'),
    },
    {
        path: '/head-card-incentives',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/head-card-incentives/index.jsx'),
    },
    {
        path: '/head-card-incentives/month-historical-rewards',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/head-card-incentives/month-historical-rewards.jsx'),
    },
    {
        path: '/head-card-incentives/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/head-card-incentives/rule.jsx'),
    },
    {
        path: '/hero-ranking/:month',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/hero-ranking/Sprint.jsx'),
    },
    {
        path: '/hero-ranking/rule/:month',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/hero-ranking/SprintReward.jsx'),
    },
    {
        path: '/hero-ranking/jhl/:month',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/hero-ranking/TopCompetition.jsx'),
    },
    {
        path: '/incentive-honus',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/incentive-honus/index.jsx'),
    },
    {
        path: '/incentive-honus/rules',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/incentive-honus/rule.jsx'),
    },
    {
        path: '/incentive-honus-share',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/incentive-honus/share.jsx'),
    },
    {
        path: '/merit-reward-v2-v7/history-increment',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/merit-reward/history-increment.jsx'),
    },
    {
        path: '/merit-reward-v2-v7',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/merit-reward/index.jsx'),
    },
    {
        path: '/monthly-activation',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/monthly-activation/index.jsx'),
    },
    {
        path: '/myDirectUpgradeLevel',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/my-direct-upgrade-level/index.jsx'),
    },
    {
        path: '/nine-rush',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/nine-active/index.jsx'),
    },
    {
        path: '/old-customer-recall',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/old-customer-recall/index.jsx'),
    },
    {
        path: '/package-sign',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/package-sign/index.jsx'),
    },
    {
        path: '/personalPromotion',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/personal-promotion/index.jsx'),
    },
    {
        path: '/personalPromotion/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/personal-promotion/rule.jsx'),
    },
    {
        path: '/direct/activityReward',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/policy-direct/ActivityReward.jsx'),
    },
    {
        path: '/polymerizationPage',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/polymerization-page/index.jsx'),
    },
    {
        path: '/purchase-travel-Q4',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/purchase-travel-Q4/index.jsx'),
    },
    {
        path: '/purchase-travel-twice',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/purchase-travel-twice/index.jsx'),
    },
    {
        path: '/purchase-travel',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/purchase-travel/index.jsx'),
    },
    {
        path: '/q3-team-growth-incentives',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/q3-team-growth-incentives/index.jsx'),
    },
    {
        path: '/combat-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/combat-list.jsx'),
    },
    {
        path: '/create-match',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/create-match.jsx'),
    },
    {
        path: '/game-description',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/game-description.jsx'),
    },
    {
        path: '/red-blue-combat',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/index.jsx'),
    },
    {
        path: '/one-page-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/one-page-list.jsx'),
    },
    {
        path: '/preheat-combat',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/preheat-combat.jsx'),
    },
    {
        path: '/share-battle',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/share-battle.jsx'),
    },
    {
        path: '/top-king-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/red-blue-combat/top-king-list.jsx'),
    },
    {
        path: '/security-levelup-ceremonial',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/security-levelup-ceremonial/SecurityLevelUpCeremonial.jsx'),
    },
    {
        path: '/studio-activation-standard/award-record',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-activation-standard/award-record.jsx'),
    },
    {
        path: '/studio-activation-standard',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-activation-standard/index.jsx'),
    },
    {
        path: '/studio-activation-standard/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-activation-standard/rule.jsx'),
    },
    {
        path: '/studio-quick-v3/butler-list-current',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-quick-v3/butler-list-current.jsx'),
    },
    {
        path: '/studio-quick-v3/butler-list-prev',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-quick-v3/butler-list-prev.jsx'),
    },
    {
        path: '/studio-quick-v3/butler-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-quick-v3/butler-list.jsx'),
    },
    {
        path: '/studio-quick-v3',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-quick-v3/index.jsx'),
    },
    {
        path: '/studio-quick-v3/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/studio-quick-v3/rule.jsx'),
    },
    {
        path: '/targetedTrainingAward',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/targeted-training-award/index.jsx'),
    },
    {
        path: '/targetedTrainingAward/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/targeted-training-award/rule.jsx'),
    },
    {
        path: '/team-apply-equipment-Q4',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/team-apply-equipment-Q4/index.jsx'),
    },
    {
        path: '/team-apply-equipment',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/team-apply-equipment/index.jsx'),
    },
    {
        path: '/team-growth-incentives-Q4',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/team-growth-incentives-Q4/index.jsx'),
    },
    {
        path: '/team-growth-incentives',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/team-growth-incentives/index.jsx'),
    },
    {
        path: '/ten-points-exchange-luxury',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/ten-points-exchange-luxury/index.jsx'),
    },
    {
        path: '/ten-points-exchange-luxury-rank',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/ten-points-exchange-luxury/rankList.jsx'),
    },
    {
        path: '/ten-points-exchange-luxury/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/ten-points-exchange-luxury/rule.jsx'),
    },
    {
        path: '/transactionIncrease',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/transaction-increase/index.jsx'),
    },
    {
        path: '/transactionIncrease/ranking',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/transaction-increase/ranking.jsx'),
    },
    {
        path: '/transactionIncrease/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/transaction-increase/rule.jsx'),
    },
    {
        path: '/user/recall',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/user-recall/index.jsx'),
    },
    {
        path: '/v1-butler-dividend',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/v1-butler-dividend/index.jsx'),
    },
    {
        path: '/v3-v5-coefficient-amplification/butler-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/v3-v5-coefficient-amplification/butler-list.jsx'),
    },
    {
        path: '/v3-v5-coefficient-amplification/effective-butler',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/v3-v5-coefficient-amplification/effective-butler.jsx'),
    },
    {
        path: '/v3-v5-coefficient-amplification',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/v3-v5-coefficient-amplification/index.jsx'),
    },
    {
        path: '/v3-v5-coefficient-amplification/rule',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/v3-v5-coefficient-amplification/rule.jsx'),
    },
    {
        path: '/wuliao/private',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/wuliao-private/index.jsx'),
    },
    {
        path: '/wuliao',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/wuliao/index.jsx'),
    },
    {
        path: '/yesterday-war-report',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/activities/yesterday-war-report/index.jsx'),
    },
    {
        path: '/agentHistoryListPage',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/agentService/AgentHistoryListPage.jsx'),
    },
    {
        path: '/agentService',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/agentService/AgentServicePage.jsx'),
    },
    {
        path: '/register/belong-apply',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/belong-apply/BelongApply.jsx'),
    },
    {
        path: '/register/belong-apply-success',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/belong-apply/BelongApplySuccess.jsx'),
    },
    {
        path: '/bindTianQueATSN',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/BindTQSN/BindTianQueSNPage.jsx'),
    },
    {
        path: '/ceremonial',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/businessCeremonial/BusinessCeremonial.jsx'),
    },
    {
        path: '/ceo/direct',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/ceo-direct/index.jsx'),
    },
    {
        path: '/coupon-detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/coupon-detail/index.jsx'),
    },
    {
        path: '/cs66/orders/:bizType/:bizNo',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/cs66-orders/detail.jsx'),
    },
    {
        path: '/cs66/orders',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/cs66-orders/index.jsx'),
    },
    {
        path: '/cs66/public/agreement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/cs66-public/AgreementPage.jsx'),
    },
    {
        path: '/cs66/public/checkout',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/cs66-public/CheckoutPage.jsx'),
    },
    {
        path: '/cs66/public/result',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/cs66-public/PaymentResultPage.jsx'),
    },
    {
        path: '/managementDetail/:id?',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data_management_pd/managementDetail.jsx'),
    },
    {
        path: '/shareManagementDetail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data_management_pd/shareManagementDetail.jsx'),
    },
    {
        path: '/data-traffic/confirmation',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/Confirmation.jsx'),
    },
    {
        path: '/data-traffic/helpOthers',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/HelpOthers.jsx'),
    },
    {
        path: '/data-traffic/historyDetail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/HistoryDetail.jsx'),
    },
    {
        path: '/data-traffic/historyList',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/HistoryList.jsx'),
    },
    {
        path: '/data-traffic/paymentByOthers',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/PaymentByOthers.jsx'),
    },
    {
        path: '/data-traffic/paymentBySelf',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/PaymentBySelf.jsx'),
    },
    {
        path: '/data-traffic/renew',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/data-traffic/Renew.jsx'),
    },
    {
        path: '/declining-coupon-list-detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/declining-coupon-list-detail/index.jsx'),
    },
    {
        path: '/declining_customers_old',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/declining-coupon-list-old/index.jsx'),
    },
    {
        path: '/declining_customers',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/declining-coupon-list/index.jsx'),
    },
    {
        path: '/esign/callback',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/esign-callback/index.jsx'),
    },
    {
        path: '/esign/guide',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/esign-guide/index.jsx'),
    },
    {
        path: '/example',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/example/Example.jsx'),
    },
    {
        path: '/listExample',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/example/ListExample.jsx'),
    },
    {
        path: '/webExample',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/example/WebView.example.jsx'),
    },
    {
        path: '/newbie-task',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/housekeeper-certification/HousekeeperCertification.jsx'),
    },
    {
        path: '/housekeeper-certification/SignAgreement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/housekeeper-certification/SignAgreement.jsx'),
    },
    {
        path: '/installation-details',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/installation/InstallationDetails.jsx'),
    },
    {
        path: '/installation-user-notice',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/installation/InstallationNotice.jsx'),
    },
    {
        path: '/installation-review',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/installation/InstallationReview.jsx'),
    },
    {
        path: '/install-success',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/installation/installSuccess.jsx'),
    },
    {
        path: '/invite-install',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/installation/InviteInstall.jsx'),
    },
    {
        path: '/jiangwutang/detail/:activityId',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/jiangwutang/JiangwutangDetail.jsx'),
    },
    {
        path: '/jiangwutang/invitation/:activityId',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/jiangwutang/JiangwutangInvitation.jsx'),
    },
    {
        path: '/jiangwutang',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/jiangwutang/JiangwutangList.jsx'),
    },
    {
        path: '/jiangwutang/payment/:activityId',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/jiangwutang/JiangwutangPayment.jsx'),
    },
    {
        path: '/knowledge/cert/:id',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/accreditation/authCertificate/index.jsx'),
    },
    {
        path: '/knowledge/auth/:id',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/accreditation/authDetail/index.jsx'),
    },
    {
        path: '/knowledge/question/:id',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/accreditation/authTest/index.jsx'),
    },
    {
        path: '/knowledge/accreditedList',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/accreditation/home/index.jsx'),
    },
    {
        path: '/knowledge/normInfo',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/normInfo/Demo.jsx'),
    },
    {
        path: '/knowledge/norm',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/normInfo/NormInfo.jsx'),
    },
    {
        path: '/knowledge/share',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/shareSource/index.jsx'),
    },
    {
        path: '/knowledge/wikiInfo',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/wikiInfo/Demo.jsx'),
    },
    {
        path: '/knowledge/wiki',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/channelInfo/wikiInfo/WikiInfo.jsx'),
    },
    {
        path: '/knowledge/demo',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/home/Demo.jsx'),
    },
    {
        path: '/knowledge/home',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/home/Home.jsx'),
    },
    {
        path: '/knowledge/hot',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/homeInfo/hotTopic/HotTopic.jsx'),
    },
    {
        path: '/knowledge/expand',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/homeInfo/normExpand/NormExpand.jsx'),
    },
    {
        path: '/knowledge/useful',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/knowledge-base/homeInfo/usefulCourses/UsefulCourses.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/balance-records',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/balance-records.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/compliance-reward.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/settlement-list/status',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/payment-status.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/settlement-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/settlement-list.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/settlement/state',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/settlement-state.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/settlement/state2',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/settlement-state2.jsx'),
    },
    {
        path: '/marketing-rewards-account/compliance-reward/settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/activate-achievement-rewards/settlement.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/balance-records',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/balance-records.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/index.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/settlement-detail.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/settlement-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/settlement-list.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/settlement-state',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/settlement-state.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/state2',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/settlement-state2.jsx'),
    },
    {
        path: '/marketing-rewards-account/added-reward-settlement/settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/added-reward-settlement/settlement.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/balance-records',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/balance-records.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/card-app-rewards-list.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/settlement-list/status',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/payment-status.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/settlement-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/settlement-list.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/settlement/state',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/settlement-state.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/settlement/state2',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/settlement-state2.jsx'),
    },
    {
        path: '/marketing-rewards-account/card-app-list/settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/card-app-rewards/settlement.jsx'),
    },
    {
        path: '/marketing-rewards-account',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/index.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/balance-records',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/balance-records.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/index.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/settlement-detail.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/settlement-list',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/settlement-list.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/settlement-state',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/settlement-state.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/state2',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/settlement-state2.jsx'),
    },
    {
        path: '/marketing-rewards-account/marketing-reward-settlement/settlement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/marketing-rewards-account/marketing-reward-settlement/settlement.jsx'),
    },
    {
        path: '/material/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/articleDetails/index.jsx'),
    },
    {
        path: '/material/home',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/home/index.jsx'),
    },
    {
        path: '/material/poster/:officeCode',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/posterList/index.jsx'),
    },
    {
        path: '/material/posterDetail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/posterList/posterDetail/index.jsx'),
    },
    {
        path: '/material/search',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/searchPage/index.jsx'),
    },
    {
        path: '/material/speech',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/material/speechList/index.jsx'),
    },
    {
        path: '/meeting/home',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/home/Home.jsx'),
    },
    {
        path: '/meeting/initiatorMeetingDetails',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/initiatorMeetingDetails/InitiatorMeetingDetails.jsx'),
    },
    {
        path: '/meeting/invite',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/inviteMeeting/index.jsx'),
    },
    {
        path: '/meeting/launch',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/launchMeeting/index.jsx'),
    },
    {
        path: '/meeting/detail',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/meetingDetails/index.jsx'),
    },
    {
        path: '/meeting/meetingQRCode',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/meetingQRCode/MeetingQRCode.jsx'),
    },
    {
        path: '/meeting/mine',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/mine/Mine.jsx'),
    },
    {
        path: '/meeting/ranking/:id/:type',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/ranking/RankingList.jsx'),
    },
    {
        path: '/meeting/sign',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/meeting-management/signResult/index.jsx'),
    },
    {
        path: '/newbie_start_tutorial',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/newbie_start_tutorial/NewbieStartTutorial.jsx'),
    },
    {
        path: '/newbie_start_tutorial/result',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/newbie_start_tutorial/NewbieStartTutorialResult.jsx'),
    },
    {
        path: '/newbie-task/NewbieTask',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/newbie-task/NewbieTask.jsx'),
    },
    {
        path: '/newbie-task/SignAgreement',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/newbie-task/SignAgreement.jsx'),
    },
    {
        path: '/questionAnswer',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/question-answer/index.jsx'),
    },
    {
        path: '/questionnaire-investigation/QuestionnaireInvestigation',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/questionnaire-investigation/QuestionnaireInvestigation.jsx'),
    },
    {
        path: '/questionnaire-investigation/Target',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/questionnaire-investigation/Target.jsx'),
    },
    {
        path: '/reg/:referralCode',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/register/allRegister.jsx'),
    },
    {
        path: '/shareDownload',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/share-download/shareWxdownload.jsx'),
    },
    {
        path: '/studio/scan/:code?',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/studio/StudioScan.jsx'),
    },
    {
        path: '/studio/workWechat/bind/:weiXinUserId',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/studio/work-wechat/account-bind/Bind.jsx'),
    },
    {
        path: '/studio/workWechat/bindSuccess',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/studio/work-wechat/account-bind/BindSuccess.jsx'),
    },
    {
        path: '/studio/workWechat',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/studio/work-wechat/account-bind/index.jsx'),
    },
    {
        path: '/xiaoeknow/login',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/xiaoeknow/Login.jsx'),
    },
    {
        path: '/xinyi-pay',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/xinyiPay/index.jsx'),
    },
    {
        path: '/EndingBill',
        component: () => import('/home/app/.jenkins/workspace/XLM-APP-WEB-PROD_241127-111718/src/pages/year-end-bill/2023_EndingBill/EndingBill.jsx'),
    }
];
    